var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{style:(_vm.buttonStyle),on:{"mouseenter":function($event){_vm.isHovered = true},"mouseleave":function($event){_vm.isHovered = false},"mousedown":function($event){_vm.isActive = true},"mouseup":function($event){_vm.isActive = false}}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }